import SectionBannerAlt from './SectionBannerAlt'
export default SectionBannerAlt